import { workspaceRequest } from "./workspaceApiShared";

export function getWorkspaceComplianceProfile(workspaceId, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/compliance-profile`, {
    token,
    fallback: "Unable to load workspace compliance profile.",
  });
}

export function updateWorkspaceComplianceProfile(workspaceId, payload, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/compliance-profile`, {
    method: "PUT",
    token,
    body: payload,
    fallback: "Unable to save workspace compliance profile.",
  });
}

export function getWorkspaceOwnershipRules(workspaceId, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/ownership-rules`, {
    token,
    fallback: "Unable to load workspace ownership rules.",
  });
}

export function updateWorkspaceOwnershipRules(workspaceId, payload, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/ownership-rules`, {
    method: "PUT",
    token,
    body: payload,
    fallback: "Unable to save workspace ownership rules.",
  });
}

export function getWorkspaceAgreements(workspaceId, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/agreements`, {
    token,
    fallback: "Unable to load workspace agreements.",
  });
}

export function createWorkspaceAgreementTemplate(workspaceId, payload, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/agreements/templates`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to create workspace agreement template.",
  });
}

export function acceptWorkspaceAgreement(workspaceId, payload, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/agreements/accept`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to record workspace agreement acceptance.",
  });
}

export function getWorkspaceWarnings(workspaceId, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/warnings`, {
    token,
    fallback: "Unable to load workspace warnings.",
  });
}

export function acknowledgeWorkspaceWarnings(workspaceId, payload, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/warnings/acknowledge`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to acknowledge workspace warnings.",
  });
}

export function listWorkspaceAuditEvents(workspaceId, token, limit = 100) {
  return workspaceRequest(`/workspaces/${workspaceId}/audit-events?limit=${limit}`, {
    token,
    fallback: "Unable to load workspace audit events.",
  });
}

export function getWorkspaceAuditEvents(workspaceId, token, limit = 100) {
  return listWorkspaceAuditEvents(workspaceId, token, limit);
}
